<template>
    <div>
         <h1 class="display-3 ma-5 pa-5 indigo darken-1 white--text rounded-tl-xl" >Gestão</h1>
        <v-divider class="mb-6"></v-divider>

<v-card class="ma-5 pa-5">
    <v-layout row justify-center >

        
        <v-flex xs4 >

            <v-text-field type="date" label="Data inicial" v-model="dates.ini" prepend-icon="fa fa-calendar" ></v-text-field>
            <v-text-field type="date" label="Data final" v-model="dates.fim" prepend-icon="fa fa-calendar" ></v-text-field>
           
             <!-- <v-menu
                ref="menu"
               
                :close-on-content-click="false"
                :return-value.sync="dates"
                transition="scale-transition"
                offset-y
                min-width="290px"
             >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dates"
                label="Selecione a data"
                prepend-icon="fa fa-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>

            </template>
        
            <v-date-picker  v-model="dates" locale="pt-BR" range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="recarregarData() ">OK</v-btn>
            </v-date-picker>
        </v-menu> -->



            <p class="grey--text darken-2" >Por padrão é carregado 10 dias de relatório</p>           
            </v-flex>
            
        </v-layout>
        <v-row justify="center">
             <v-col cols="8">
                <v-btn block :disabled="!dates.ini || !dates.fim" @click="recarregarData" class="green lighten-2 white--text" >Recarregar com datas</v-btn>
            </v-col>
            
        <v-col cols="8">
                <v-select
                prepend-inner-icon="mdi-face"
            :items="barbeiros"
            item-text="nome"
            item-value="id"
            v-model="barbeiroFiltrado"
            label="Filtre por barbeiro"
            @change="filtrarPorBarbeiro"
            dense
            ></v-select>

        </v-col>

        <v-col cols="8" >
            <v-btn block :disabled="!usarBarbeiro || !usarData" @click="limparFiltro">Limpar filtros</v-btn>
        </v-col>
        </v-row>
        
    </v-card>
 
    
        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Receita por barbeiro (dias filtrados acima)</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <div class="receita-pizza">
                <svg
                    v-if="pizzaSlices.length"
                    class="receita-pizza__svg"
                    viewBox="0 0 320 320"
                    aria-label="Gráfico de receita por barbeiro"
                >
                    <g transform="translate(160,160)">
                        <path
                            v-for="slice in pizzaSlices"
                            :key="slice.nome"
                            :d="slice.path"
                            :fill="slice.color"
                            stroke="#ffffff"
                            stroke-width="3"
                        ></path>

                        <g
                            v-for="slice in pizzaSlices"
                            :key="slice.nome + '-label'"
                            class="receita-pizza__slice-label"
                            :transform="`translate(${slice.labelX}, ${slice.labelY})`"
                        >
                            <text class="receita-pizza__slice-value" text-anchor="middle">
                                {{ slice.shortValue }}
                            </text>
                        </g>

                        <circle cx="0" cy="0" r="56" fill="#ffffff"></circle>
                        <text x="0" y="-4" text-anchor="middle" class="receita-pizza__center-title">
                            Total
                        </text>
                        <text x="0" y="22" text-anchor="middle" class="receita-pizza__center-value">
                            {{ totalReceitaFormatada }}
                        </text>
                    </g>
                </svg>

                <div v-else class="receita-pizza__empty">
                    Sem dados de receita no periodo selecionado.
                </div>
            </div>

            <div class="receita-pizza__legend">
                <div
                    v-for="item in receitaPorBarbeiro"
                    :key="item.barbeiro"
                    class="receita-pizza__legend-item"
                >
                    <div class="receita-pizza__legend-main">
                        <span
                            class="receita-pizza__legend-color"
                            :style="{ backgroundColor: item.color }"
                        ></span>
                        <div>
                            <div class="receita-pizza__legend-name">{{ item.barbeiro }}</div>
                            <div class="receita-pizza__legend-qty">
                                {{ item.quantidade }} agendamento<span v-if="item.quantidade !== 1">s</span>
                            </div>
                        </div>
                    </div>
                    <div class="receita-pizza__legend-value">
                        {{ formatarMoeda(item.receita) }}
                    </div>
                </div>
            </div>

            <div class="mt-8">
                <v-card-title class="text-h5 px-0">Receita dos últimos 10 dias</v-card-title>
                <p class="grey--text mb-4">
                    Mostra os últimos 10 dias corridos com destaque para hoje e valor em cada barra.
                </p>
                <div class="receita-chart">
                    <div
                        v-for="item in receitaUltimos10Dias"
                        :key="item.data"
                        class="receita-chart__item"
                        :class="{ 'receita-chart__item--today': item.isToday }"
                    >
                        <div class="receita-chart__value">
                            {{ item.valorFormatado }}
                        </div>
                        <div class="receita-chart__bar-wrapper">
                            <div
                                class="receita-chart__bar"
                                :style="{ height: item.altura }"
                            ></div>
                        </div>
                        <div class="receita-chart__date">{{ item.label }}</div>
                        <div class="receita-chart__day">
                            {{ item.isToday ? 'Hoje' : item.diaSemana }}
                        </div>
                    </div>
                </div>
            </div>
 

        </v-card>

        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Serviços mais vendidos</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <div class="services-summary">
                <div class="services-summary__card">
                    <div class="services-summary__label">Receita total</div>
                    <div class="services-summary__value">{{ formatarMoeda(totalReceitaServicos) }}</div>
                </div>
                <div class="services-summary__card">
                    <div class="services-summary__label">Atendimentos</div>
                    <div class="services-summary__value">{{ totalQuantidadeServicos }}</div>
                </div>
                <div class="services-summary__card">
                    <div class="services-summary__label">Mais forte</div>
                    <div class="services-summary__value services-summary__value--small">
                        {{ servicoDestaque ? servicoDestaque.servico : 'Sem dados' }}
                    </div>
                </div>
            </div>

            <div class="services-ranking">
                <div
                    v-for="(item, index) in receitaPorServico"
                    :key="item.chave"
                    class="services-ranking__item"
                >
                    <div class="services-ranking__header">
                        <div class="services-ranking__title-group">
                            <div class="services-ranking__badge">#{{ index + 1 }}</div>
                            <div>
                                <div class="services-ranking__title">{{ item.servico }}</div>
                                <div class="services-ranking__meta">
                                    {{ item.quantidade }} venda<span v-if="item.quantidade !== 1">s</span>
                                    <span class="services-ranking__dot"></span>
                                    {{ item.percentualReceita }} da receita
                                </div>
                            </div>
                        </div>
                        <div class="services-ranking__money">
                            {{ formatarMoeda(item.receita) }}
                        </div>
                    </div>

                    <div class="services-ranking__bar-track">
                        <div
                            class="services-ranking__bar-fill"
                            :style="{ width: item.percentualBarra }"
                        ></div>
                    </div>

                    <div class="services-ranking__footer">
                        <div class="services-ranking__info">
                            Ticket médio: <strong>{{ formatarMoeda(item.ticketMedio) }}</strong>
                        </div>
                        <div class="services-ranking__info">
                            Participação em atendimentos: <strong>{{ item.percentualQuantidade }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>

        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Quantidade por tipo de serviço</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <p class="grey--text mb-4">
                Separa quantos atendimentos foram de cada serviço no período filtrado.
                A soma das quantidades fecha com o total de agendamentos.
            </p>

            <div class="quantidade-summary">
                <div class="quantidade-summary__card">
                    <div class="quantidade-summary__label">Agendamentos no período</div>
                    <div class="quantidade-summary__value">{{ totalAgendamentos }}</div>
                </div>
                <div class="quantidade-summary__card">
                    <div class="quantidade-summary__label">Tipos de serviço</div>
                    <div class="quantidade-summary__value">{{ quantidadePorServico.length }}</div>
                </div>
                <div class="quantidade-summary__card">
                    <div class="quantidade-summary__label">Mais realizado</div>
                    <div class="quantidade-summary__value quantidade-summary__value--small">
                        {{ servicoMaisRealizado ? servicoMaisRealizado.servico : 'Sem dados' }}
                    </div>
                </div>
            </div>

            <div v-if="quantidadePorServico.length" class="quantidade-share">
                <div
                    v-for="item in quantidadePorServico"
                    :key="item.chave + '-share'"
                    class="quantidade-share__segment"
                    :style="{ width: item.percentualShare, backgroundColor: item.color }"
                    :title="`${item.servico}: ${item.quantidade}`"
                ></div>
            </div>

            <div class="quantidade-grid">
                <div
                    v-for="item in quantidadePorServico"
                    :key="item.chave"
                    class="quantidade-card"
                >
                    <div class="quantidade-card__top">
                        <span
                            class="quantidade-card__color"
                            :style="{ backgroundColor: item.color }"
                        ></span>
                        <div class="quantidade-card__name">
                            {{ item.servico }}
                            <span v-if="!item.noCatalogo" class="quantidade-card__tag">
                                fora do catálogo
                            </span>
                        </div>
                    </div>

                    <div class="quantidade-card__number">{{ item.quantidade }}</div>
                    <div class="quantidade-card__caption">
                        atendimento<span v-if="item.quantidade !== 1">s</span>
                        · {{ item.percentualQuantidade }} do total
                    </div>

                    <div class="quantidade-card__bar-track">
                        <div
                            class="quantidade-card__bar-fill"
                            :style="{ width: item.percentualBarra, backgroundColor: item.color }"
                        ></div>
                    </div>

                    <div class="quantidade-card__footer">
                        <span>Receita: <strong>{{ formatarMoeda(item.receita) }}</strong></span>
                        <span>Ticket médio: <strong>{{ formatarMoeda(item.ticketMedio) }}</strong></span>
                    </div>
                </div>
            </div>

            <div v-if="!quantidadePorServico.length" class="quantidade-empty">
                Sem serviços realizados no periodo selecionado.
            </div>
        </v-card>

        <v-card class="pa-5 ma-5">
            <div class="grey lighten-3" >

            <v-card-title class="display-2" >Receita por clientes (15 maiores)</v-card-title>
            </div>
            <v-divider class="mb-5" ></v-divider>
            <div class="clients-summary">
                <div class="clients-summary__card">
                    <div class="clients-summary__label">Receita top 15</div>
                    <div class="clients-summary__value">{{ formatarMoeda(totalReceitaClientes) }}</div>
                </div>
                <div class="clients-summary__card">
                    <div class="clients-summary__label">Atendimentos top 15</div>
                    <div class="clients-summary__value">{{ totalQuantidadeClientes }}</div>
                </div>
                <div class="clients-summary__card">
                    <div class="clients-summary__label">Cliente destaque</div>
                    <div class="clients-summary__value clients-summary__value--small">
                        {{ clienteDestaque ? clienteDestaque.nome : 'Sem dados' }}
                    </div>
                </div>
            </div>

            <div class="clients-ranking">
                <div
                    v-for="(item, index) in receitaPorUsuario"
                    :key="item.email"
                    class="clients-ranking__item"
                >
                    <div class="clients-ranking__header">
                        <div class="clients-ranking__identity">
                            <div class="clients-ranking__badge">#{{ index + 1 }}</div>
                            <div class="clients-ranking__user">
                                <div class="clients-ranking__name">{{ item.nome }}</div>
                                <div class="clients-ranking__contact">{{ item.telefone }}</div>
                                <div class="clients-ranking__contact">{{ item.email }}</div>
                            </div>
                        </div>
                        <div class="clients-ranking__money">
                            {{ formatarMoeda(item.receita) }}
                        </div>
                    </div>

                    <div class="clients-ranking__bar-track">
                        <div
                            class="clients-ranking__bar-fill"
                            :style="{ width: item.percentualBarra }"
                        ></div>
                    </div>

                    <div class="clients-ranking__footer">
                        <div class="clients-ranking__info">
                            {{ item.quantidade }} agendamento<span v-if="item.quantidade !== 1">s</span>
                        </div>
                        <div class="clients-ranking__info">
                            Ticket médio: <strong>{{ formatarMoeda(item.ticketMedio) }}</strong>
                        </div>
                        <div class="clients-ranking__info">
                            Participação: <strong>{{ item.percentualReceita }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {refAgenda, refBarbeiros,refFuncoes} from '@/firebaseConfig'
    export default {
        data() {
            return {
                dates: {},
                usarData: false,
                usarBarbeiro: false,
                refAgenda: refAgenda,
                refBarbeiros: refBarbeiros,
                refFuncoes: refFuncoes,
                barbeiros: [],
                barbeiroFiltrado: '',
                receitaPorBarbeiro:[],
                receitaPorBarbeiroChart: [],
                receitaUltimos10Dias: [],
                listaAgenda: [],
                servicosCatalogo: [],
                receitaPorServico: [],
                quantidadePorServico: [],
                receitaPorUsuario: [],
            }
        },
        computed: {
         ...mapGetters(["getCurrentUser", "isUserAuth"]),
         diasMilliSeconds: function() {
             let diasRetornar = 10
             return (24 * 60 * 60 * 1000) * diasRetornar
         },
         totalReceita() {
             return this.receitaPorBarbeiro.reduce((acc, item) => acc + item.receita, 0)
         },
         totalReceitaFormatada() {
             return this.formatarMoeda(this.totalReceita)
         },
         totalReceitaServicos() {
             return this.receitaPorServico.reduce((acc, item) => acc + item.receita, 0)
         },
         totalQuantidadeServicos() {
             return this.receitaPorServico.reduce((acc, item) => acc + item.quantidade, 0)
         },
         servicoDestaque() {
             return this.receitaPorServico.length ? this.receitaPorServico[0] : null
         },
         totalAgendamentos() {
             return this.listaAgenda.length
         },
         servicoMaisRealizado() {
             return this.quantidadePorServico.length ? this.quantidadePorServico[0] : null
         },
         totalReceitaClientes() {
             return this.receitaPorUsuario.reduce((acc, item) => acc + item.receita, 0)
         },
         totalQuantidadeClientes() {
             return this.receitaPorUsuario.reduce((acc, item) => acc + item.quantidade, 0)
         },
         clienteDestaque() {
             return this.receitaPorUsuario.length ? this.receitaPorUsuario[0] : null
         },
         pizzaSlices() {
             if (!this.receitaPorBarbeiro.length || !this.totalReceita) {
                 return []
             }

             let startAngle = -Math.PI / 2

             return this.receitaPorBarbeiro.map((item) => {
                 const fraction = item.receita / this.totalReceita
                 const angle = fraction * Math.PI * 2
                 const endAngle = startAngle + angle
                 const largeArcFlag = angle > Math.PI ? 1 : 0
                 const outerRadius = 132
                 const labelRadius = 94
                 const startX = Math.cos(startAngle) * outerRadius
                 const startY = Math.sin(startAngle) * outerRadius
                 const endX = Math.cos(endAngle) * outerRadius
                 const endY = Math.sin(endAngle) * outerRadius
                 const midAngle = startAngle + angle / 2

                 const slice = {
                     nome: item.barbeiro,
                     color: item.color,
                     path: `M 0 0 L ${startX} ${startY} A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${endX} ${endY} Z`,
                     labelX: Math.cos(midAngle) * labelRadius,
                     labelY: Math.sin(midAngle) * labelRadius,
                     shortValue: this.formatarMoedaCurta(item.receita),
                 }

                 startAngle = endAngle
                 return slice
             })
         }

        },
        async created(){
            await this.carregarRelatorios();
        },
        methods: {
            async carregarRelatorios(){
                this.limparDados()
                const { dataIn, dataFim } = this.obterPeriodo()

                const barbeirosSnap = await this.refBarbeiros.get()
                this.barbeiros = barbeirosSnap.docs.map((doc) => ({ ...doc.data() }))

                const barbeirosSelecionados = this.usarBarbeiro
                    ? this.barbeiros.filter((item) => item.id === this.barbeiroFiltrado)
                    : this.barbeiros

                const agendaPorBarbeiro = await Promise.all(
                    barbeirosSelecionados.map(async (barbeiro) => {
                        const snap = await this.refAgenda
                            .where("barbeiro.id","==",barbeiro.id)
                            .where("dataQuery", ">=", dataIn)
                            .where("dataQuery", "<=", dataFim)
                            .get()

                        const agendamentos = snap.docs
                            .map((doc) => doc.data())
                            .filter((agenda) => typeof agenda.servico !== "undefined")

                        return { barbeiro, agendamentos }
                    })
                )

                this.montarReceitaPorBarbeiro(agendaPorBarbeiro)
                await this.carregarReceitaUltimos10Dias(barbeirosSelecionados)
                await this.carregarVendasPorServico()
                this.carregarReceitaPorUsuario()
            },
            async limparFiltro(){
                this.usarBarbeiro = false
                this.usarData = false
                this.barbeiroFiltrado = ''
                await this.carregarRelatorios();
            },
            async filtrarPorBarbeiro(){
                this.usarBarbeiro = !!this.barbeiroFiltrado
                await this.carregarRelatorios();
            },
            async recarregarData(){
                this.usarData = !!this.dates.ini && !!this.dates.fim
                await this.carregarRelatorios();
            },
            
            limparDados(){
                this.receitaPorBarbeiro = []
                this.receitaPorBarbeiroChart = []
                this.receitaUltimos10Dias = []
                this.listaAgenda = []
                this.servicosCatalogo = []
                this.receitaPorServico = []
                this.quantidadePorServico = []
                this.receitaPorUsuario = []
            },
            obterPeriodo(){
                if(this.usarData && this.dates.ini && this.dates.fim){
                    return {
                        dataIn: new Date(this.dates.ini + 'T00:00:00').getTime(),
                        dataFim: new Date(this.dates.fim + 'T23:59:59').getTime()
                    }
                }

                return {
                    dataIn: new Date().getTime() - this.diasMilliSeconds,
                    dataFim: new Date().getTime()
                }
            },
            montarReceitaPorBarbeiro(agendaPorBarbeiro){
                const chartColors = ["#3949ab", "#1e88e5", "#00897b", "#43a047", "#fb8c00", "#8e24aa"]
                this.receitaPorBarbeiro = []
                this.receitaPorBarbeiroChart = []
                this.listaAgenda = []

                agendaPorBarbeiro.forEach(({ barbeiro, agendamentos }, index) => {
                    let receita = 0

                    agendamentos.forEach((agenda) => {
                        const valor = parseFloat(agenda.servico.preco) || 0
                        receita += valor
                        this.listaAgenda.push(agenda)
                    })

                    this.receitaPorBarbeiro.push({
                        quantidade: agendamentos.length,
                        receita: receita,
                        barbeiro: barbeiro.nome,
                        color: chartColors[index % chartColors.length]
                    })

                    this.receitaPorBarbeiroChart.push([barbeiro.nome, receita])
                })

                this.receitaPorBarbeiro.sort((a,b) => a.receita > b.receita ? -1 : 1)
            },
            async carregarReceitaUltimos10Dias(barbeirosSelecionados){
                const hoje = new Date()
                hoje.setHours(23, 59, 59, 999)

                const inicio = new Date()
                inicio.setHours(0, 0, 0, 0)
                inicio.setDate(inicio.getDate() - 9)

                const receitasPorData = {}
                const promessas = barbeirosSelecionados.map(async (barbeiro) => {
                    const snap = await this.refAgenda
                        .where("barbeiro.id","==",barbeiro.id)
                        .where("dataQuery", ">=", inicio.getTime())
                        .where("dataQuery", "<=", hoje.getTime())
                        .get()

                    snap.forEach((doc) => {
                        const agenda = doc.data()
                        if(!agenda.servico){
                            return
                        }

                        const chave = this.obterChaveData(agenda)
                        receitasPorData[chave] = (receitasPorData[chave] || 0) + (parseFloat(agenda.servico.preco) || 0)
                    })
                })

                await Promise.all(promessas)

                const maiorValor = Math.max(...Object.values(receitasPorData), 0)
                const diasSemana = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"]
                const lista = []

                for(let i = 9; i >= 0; i--){
                    const data = new Date()
                    data.setHours(0, 0, 0, 0)
                    data.setDate(data.getDate() - i)

                    const chave = this.formatarDataISO(data)
                    const valor = receitasPorData[chave] || 0
                    const alturaCalculada = maiorValor > 0 ? Math.max((valor / maiorValor) * 180, valor > 0 ? 24 : 10) : 10

                    lista.push({
                        data: chave,
                        valor,
                        valorFormatado: `R$ ${valor.toLocaleString('pt-BR')}`,
                        label: this.formatarDataCurta(data),
                        diaSemana: diasSemana[data.getDay()],
                        isToday: i === 0,
                        altura: `${alturaCalculada}px`
                    })
                }

                this.receitaUltimos10Dias = lista
            },
           
        
        async carregarVendasPorServico(){
            const snap = await refFuncoes.get()
            this.servicosCatalogo = snap.docs.map((doc) => ({...doc.data(), id: doc.data().id || doc.id}))

            const agrupados = this.agruparPorServico(this.listaAgenda)

            this.receitaPorServico = agrupados
                .slice()
                .sort((a,b) => a['receita'] > b['receita'] ? -1 : 1)
            this.receitaPorServico = this.receitaPorServico
                .map((item) => this.completarMetricasServico(item))

            this.quantidadePorServico = agrupados
                .slice()
                .sort((a,b) => a['quantidade'] > b['quantidade'] ? -1 : 1)
            this.quantidadePorServico = this.quantidadePorServico
                .map((item, index) => this.completarMetricasQuantidade(item, index))
        },
        agruparPorServico(listaAgenda){
            const catalogoPorId = {}
            this.servicosCatalogo.forEach((servico) => {
                catalogoPorId[servico.id] = servico
            })

            // Percorre os agendamentos (e nao o catalogo) para nao perder servicos
            // que foram excluidos ou recadastrados depois do atendimento.
            const agrupados = {}

            listaAgenda.forEach((agenda) => {
                const servicoAgenda = agenda.servico || {}
                const servicoCatalogo = catalogoPorId[servicoAgenda.id] || {}
                const descricao = servicoCatalogo.descricao
                    || servicoAgenda.descricao
                    || 'Serviço não identificado'
                const chave = servicoAgenda.id || descricao

                if(!agrupados[chave]){
                    agrupados[chave] = {
                        chave: chave,
                        servico: descricao,
                        quantidade: 0,
                        receita: 0,
                        noCatalogo: !!servicoCatalogo.descricao
                    }
                }

                agrupados[chave].quantidade += 1
                agrupados[chave].receita += parseFloat(servicoAgenda.preco) || 0
            })

            return Object.values(agrupados)
        },
        completarMetricasServico(item){
            const ticketMedio = item.quantidade ? item.receita / item.quantidade : 0
            const percentualReceita = this.totalReceita
                ? `${Math.round((item.receita / this.totalReceita) * 100)}%`
                : '0%'
            const percentualQuantidade = this.totalQuantidadeServicos
                ? `${Math.round((item.quantidade / this.totalQuantidadeServicos) * 100)}%`
                : '0%'
            const maiorReceita = this.receitaPorServico.length ? this.receitaPorServico[0].receita : 0
            const percentualBarra = maiorReceita
                ? `${Math.max((item.receita / maiorReceita) * 100, 8)}%`
                : '8%'

            return {
                ...item,
                ticketMedio,
                percentualReceita,
                percentualQuantidade,
                percentualBarra
            }
        },

        completarMetricasQuantidade(item, index){
            const chartColors = ["#3949ab", "#00897b", "#fb8c00", "#8e24aa", "#1e88e5", "#43a047", "#e53935", "#5d4037"]
            const totalQuantidade = this.totalAgendamentos
            const maiorQuantidade = this.quantidadePorServico.length
                ? this.quantidadePorServico[0].quantidade
                : 0

            return {
                ...item,
                color: chartColors[index % chartColors.length],
                ticketMedio: item.quantidade ? item.receita / item.quantidade : 0,
                percentualQuantidade: totalQuantidade
                    ? `${Math.round((item.quantidade / totalQuantidade) * 100)}%`
                    : '0%',
                percentualShare: totalQuantidade
                    ? `${(item.quantidade / totalQuantidade) * 100}%`
                    : '0%',
                percentualBarra: maiorQuantidade
                    ? `${Math.max((item.quantidade / maiorQuantidade) * 100, 8)}%`
                    : '8%'
            }
        },

        carregarReceitaPorUsuario(){
            const usuarios = {}

            this.listaAgenda.forEach((agenda) => {
                if(!agenda.cliente || !agenda.cliente.email){
                    return
                }

                const email = agenda.cliente.email
                if(!usuarios[email]){
                    usuarios[email] = {
                        quantidade: 0,
                        receita: 0,
                        nome: agenda.cliente.nome,
                        telefone: agenda.cliente.telefone,
                        email: email
                    }
                }

                usuarios[email].quantidade += 1
                usuarios[email].receita += parseFloat(agenda.servico.preco) || 0
            })

            this.receitaPorUsuario = Object.values(usuarios)
            this.receitaPorUsuario.sort((a,b) => a['receita'] > b['receita'] ? -1 : 1);
            this.receitaPorUsuario = this.receitaPorUsuario.slice(0, 15);
            this.receitaPorUsuario = this.receitaPorUsuario.map((item) => this.completarMetricasCliente(item))
        },
        completarMetricasCliente(item){
            const ticketMedio = item.quantidade ? item.receita / item.quantidade : 0
            const percentualReceita = this.totalReceita
                ? `${Math.round((item.receita / this.totalReceita) * 100)}%`
                : '0%'
            const maiorReceita = this.receitaPorUsuario.length ? this.receitaPorUsuario[0].receita : 0
            const percentualBarra = maiorReceita
                ? `${Math.max((item.receita / maiorReceita) * 100, 8)}%`
                : '8%'

            return {
                ...item,
                ticketMedio,
                percentualReceita,
                percentualBarra
            }
        },
        obterDiaSemana(agenda){
            const dataBase = agenda.start
                ? new Date(agenda.start.replace(' ', 'T'))
                : new Date(agenda.dataQuery)

            const indice = (dataBase.getDay() + 6) % 7
            const diasSemana = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"]
            return diasSemana[indice]
        },
        obterChaveData(agenda){
            if(agenda.start){
                return agenda.start.substring(0, 10)
            }

            return this.formatarDataISO(new Date(agenda.dataQuery))
        },
        formatarDataISO(data){
            const ano = data.getFullYear()
            const mes = `${data.getMonth() + 1}`.padStart(2, '0')
            const dia = `${data.getDate()}`.padStart(2, '0')
            return `${ano}-${mes}-${dia}`
        },
        formatarDataCurta(data){
            const dia = `${data.getDate()}`.padStart(2, '0')
            const mes = `${data.getMonth() + 1}`.padStart(2, '0')
            return `${dia}/${mes}`
        },
        formatarMoeda(valor){
            return `R$ ${Number(valor || 0).toLocaleString('pt-BR')}`
        },
        formatarMoedaCurta(valor){
            const numero = Number(valor || 0)
            if(numero >= 1000){
                return `R$ ${(numero / 1000).toFixed(1).replace('.', ',')}k`
            }
            return `R$ ${numero.toLocaleString('pt-BR')}`
        }



        }
        
    }
</script>

<style lang="scss" scoped>
.services-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.services-summary__card {
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8faff 0%, #edf2fb 100%);
  border: 1px solid #d9e1f0;
}

.services-summary__label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6a7a90;
  margin-bottom: 8px;
}

.services-summary__value {
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
  color: #1c2740;
}

.services-summary__value--small {
  font-size: 20px;
}

.services-ranking {
  display: grid;
  gap: 12px;
}

.services-ranking__item {
  padding: 16px;
  border-radius: 18px;
  background: #f6f8fc;
  border: 1px solid #dde5f1;
}

.services-ranking__header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
}

.services-ranking__title-group {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.services-ranking__badge {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #233876;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
}

.services-ranking__title {
  font-size: 18px;
  font-weight: 800;
  color: #1c2740;
}

.services-ranking__meta {
  margin-top: 4px;
  font-size: 13px;
  color: #627289;
}

.services-ranking__dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: #7d8ca3;
  margin: 0 8px;
  vertical-align: middle;
}

.services-ranking__money {
  font-size: 20px;
  font-weight: 800;
  color: #233876;
  white-space: nowrap;
}

.services-ranking__bar-track {
  margin-top: 14px;
  height: 10px;
  border-radius: 999px;
  background: #dfe7f5;
  overflow: hidden;
}

.services-ranking__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #3949ab 0%, #1e88e5 100%);
}

.services-ranking__footer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.services-ranking__info {
  font-size: 13px;
  color: #55657c;
}

.quantidade-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.quantidade-summary__card {
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8faff 0%, #edf2fb 100%);
  border: 1px solid #d9e1f0;
}

.quantidade-summary__label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6a7a90;
  margin-bottom: 8px;
}

.quantidade-summary__value {
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
  color: #1c2740;
}

.quantidade-summary__value--small {
  font-size: 20px;
}

.quantidade-share {
  display: flex;
  height: 18px;
  border-radius: 999px;
  overflow: hidden;
  background: #e3eaf5;
  margin-bottom: 20px;
}

.quantidade-share__segment {
  height: 100%;
  min-width: 3px;
}

.quantidade-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.quantidade-card {
  padding: 16px;
  border-radius: 18px;
  background: #f6f8fc;
  border: 1px solid #dde5f1;
}

.quantidade-card__top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.quantidade-card__color {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  flex: 0 0 12px;
}

.quantidade-card__name {
  font-size: 16px;
  font-weight: 800;
  color: #1c2740;
  overflow-wrap: anywhere;
}

.quantidade-card__tag {
  display: inline-block;
  margin-left: 6px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #8a5a00;
  background: #fff3d6;
  border: 1px solid #f2dca6;
  border-radius: 999px;
  padding: 1px 8px;
  vertical-align: middle;
}

.quantidade-card__number {
  margin-top: 10px;
  font-size: 40px;
  line-height: 1;
  font-weight: 800;
  color: #233876;
}

.quantidade-card__caption {
  margin-top: 4px;
  font-size: 13px;
  color: #627289;
}

.quantidade-card__bar-track {
  margin-top: 12px;
  height: 10px;
  border-radius: 999px;
  background: #dfe7f5;
  overflow: hidden;
}

.quantidade-card__bar-fill {
  height: 100%;
  border-radius: 999px;
}

.quantidade-card__footer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #55657c;
}

.quantidade-empty {
  padding: 24px;
  border-radius: 16px;
  background: #f5f7fb;
  text-align: center;
  color: #607080;
}

.clients-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.clients-summary__card {
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f9fbff 0%, #eef4fb 100%);
  border: 1px solid #d7e3ef;
}

.clients-summary__label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6a7a90;
  margin-bottom: 8px;
}

.clients-summary__value {
  font-size: 28px;
  line-height: 1.1;
  font-weight: 800;
  color: #1c2740;
}

.clients-summary__value--small {
  font-size: 20px;
}

.clients-ranking {
  display: grid;
  gap: 12px;
}

.clients-ranking__item {
  padding: 16px;
  border-radius: 18px;
  background: #f7f9fc;
  border: 1px solid #dce5f0;
}

.clients-ranking__header {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  align-items: flex-start;
}

.clients-ranking__identity {
  display: flex;
  gap: 12px;
  min-width: 0;
}

.clients-ranking__badge {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: #0d47a1;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
}

.clients-ranking__user {
  min-width: 0;
}

.clients-ranking__name {
  font-size: 18px;
  font-weight: 800;
  color: #1c2740;
}

.clients-ranking__contact {
  font-size: 13px;
  color: #627289;
  overflow-wrap: anywhere;
}

.clients-ranking__money {
  font-size: 20px;
  font-weight: 800;
  color: #0d47a1;
  white-space: nowrap;
}

.clients-ranking__bar-track {
  margin-top: 14px;
  height: 10px;
  border-radius: 999px;
  background: #dde8f4;
  overflow: hidden;
}

.clients-ranking__bar-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #1976d2 0%, #26a69a 100%);
}

.clients-ranking__footer {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.clients-ranking__info {
  font-size: 13px;
  color: #55657c;
}

.receita-chart {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  align-items: end;
}

.receita-pizza {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.receita-pizza__svg {
  width: 100%;
  max-width: 380px;
  height: auto;
}

.receita-pizza__slice-value {
  fill: #ffffff;
  font-size: 12px;
  font-weight: 700;
}

.receita-pizza__center-title {
  fill: #607080;
  font-size: 13px;
  font-weight: 700;
}

.receita-pizza__center-value {
  fill: #1d2940;
  font-size: 14px;
  font-weight: 700;
}

.receita-pizza__empty {
  width: 100%;
  padding: 24px;
  border-radius: 16px;
  background: #f5f7fb;
  text-align: center;
  color: #607080;
}

.receita-pizza__legend {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.receita-pizza__legend-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8faff 0%, #eef3fb 100%);
  border: 1px solid #d8e2f0;
}

.receita-pizza__legend-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.receita-pizza__legend-color {
  width: 12px;
  height: 44px;
  border-radius: 999px;
  flex: 0 0 12px;
}

.receita-pizza__legend-name {
  font-size: 15px;
  font-weight: 700;
  color: #1d2940;
}

.receita-pizza__legend-qty {
  font-size: 12px;
  color: #617287;
}

.receita-pizza__legend-value {
  font-size: 16px;
  font-weight: 800;
  color: #22324b;
  white-space: nowrap;
}

.receita-chart__item {
  background: #f5f7fb;
  border-radius: 14px;
  padding: 10px 6px;
  text-align: center;
  border: 1px solid #dbe3f0;
}

.receita-chart__item--today {
  background: #e8f5e9;
  border-color: #66bb6a;
}

.receita-chart__value {
  font-size: 11px;
  line-height: 1.2;
  font-weight: 700;
  color: #24324a;
  min-height: 28px;
  margin-bottom: 8px;
}

.receita-chart__bar-wrapper {
  height: 190px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.receita-chart__bar {
  width: 100%;
  max-width: 32px;
  border-radius: 10px 10px 4px 4px;
  background: linear-gradient(180deg, #5c6bc0 0%, #283593 100%);
  min-height: 10px;
}

.receita-chart__item--today .receita-chart__bar {
  background: linear-gradient(180deg, #66bb6a 0%, #2e7d32 100%);
}

.receita-chart__date {
  margin-top: 10px;
  font-size: 12px;
  font-weight: 700;
  color: #1f2d3d;
}

.receita-chart__day {
  margin-top: 2px;
  font-size: 11px;
  color: #5f6b7a;
}

@media (max-width: 960px) {
  .services-summary {
    grid-template-columns: 1fr;
  }

  .clients-summary {
    grid-template-columns: 1fr;
  }

  .quantidade-summary {
    grid-template-columns: 1fr;
  }

  .quantidade-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .receita-pizza__legend {
    grid-template-columns: 1fr;
  }

  .receita-chart {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .services-ranking__header {
    flex-direction: column;
  }

  .services-ranking__money {
    font-size: 18px;
  }

  .services-ranking__title {
    font-size: 16px;
  }

  .quantidade-grid {
    grid-template-columns: 1fr;
  }

  .quantidade-card__number {
    font-size: 34px;
  }

  .clients-ranking__header {
    flex-direction: column;
  }

  .clients-ranking__money {
    font-size: 18px;
  }

  .clients-ranking__name {
    font-size: 16px;
  }

  .receita-pizza__svg {
    max-width: 320px;
  }

  .receita-pizza__slice-value {
    font-size: 10px;
  }

  .receita-pizza__legend-item {
    align-items: flex-start;
    flex-direction: column;
  }

  .receita-pizza__legend-value {
    font-size: 15px;
    padding-left: 22px;
  }

  .receita-chart {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .receita-chart__item {
    padding: 10px 8px;
  }

  .receita-chart__bar-wrapper {
    height: 150px;
  }

  .receita-chart__bar {
    max-width: 28px;
  }

  .receita-chart__value {
    font-size: 10px;
    min-height: 26px;
  }
}
</style>
